export const durationSecond = 1000;
export const durationMinute = durationSecond * 60;
export const durationHour = durationMinute * 60;
export const durationDay = durationHour * 24;
export const durationWeek = durationDay * 7;
export const durationMonth = durationDay * 30;
export const durationYear = durationDay * 365;



//////////////////
// WEBPACK FOOTER
// ./~/d3-time/src/duration.js
// module id = 39
// module chunks = 0